import React from 'react';
import classnames from 'classnames';
import { isFunction, isEmpty } from 'lodash';
import { getContext } from '@fiverr-private/fiverr_context';
import ErrorBoundary from '../ErrorBoundary';
import { withPropsValidation } from '../../hoc/withPropsValidation';
import { LOGS_KEY } from '../../utils/constants';
import { Provider } from '../utils/context';
import { logger } from '../../shared/logger';
import { PersonalizedSectionCommonPropTypes } from '../shared/propTypes/personalizedSection.propTypes';
import { getPersonalizedCommonProps } from '../utils/propsExtractors/personalizedSection';
import { personalizedSectionValidator } from './validator';
import { getLoggableProps } from './utils';

const PersonalizedSectionCommon = (props) => {
    const {
        personalizedContent,
        sectionName,
        onError,
        isLazy,
        isLoading,
        showTranslatedUGC,
        onImpression,
        className,
        PersonalizedComponentMapper,
        rollouts,
    } = props;
    const { sections, funnelName, pageName } = personalizedContent;

    if (isEmpty(personalizedContent) || !sections || !sections[sectionName]) {
        const errorMessage = 'no-personalized-section-to-render';

        isFunction(onError) && onError(errorMessage);
        logger.info(errorMessage, {
            [LOGS_KEY]: 'PersonalizedSection rendered with invalid section or data',
            componentProps: JSON.stringify({
                section_name: sectionName,
                exists_sections: sections ? Object.keys(sections) : [],
                isLazy,
                isLoading,
                showTranslatedUGC,
                rollouts,
            }),
        });

        return null;
    }

    const { userId, pageCtxId, isTouch } = getContext();

    return (
        <ErrorBoundary {...getLoggableProps(props)} onError={onError}>
            <Provider value={{ funnelName, pageName, userId, pageCtxId, isTouch, onImpression }}>
                <section className={classnames('personalized-content', className)}>
                    {sections[sectionName].map((component, index) => (
                        <PersonalizedComponentMapper
                            key={`${component.name}-${index}`}
                            component={component}
                            {...getPersonalizedCommonProps(props)}
                        />
                    ))}
                </section>
            </Provider>
        </ErrorBoundary>
    );
};

PersonalizedSectionCommon.propTypes = PersonalizedSectionCommonPropTypes;

export default withPropsValidation(personalizedSectionValidator)(PersonalizedSectionCommon);
